import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const deep_squat_color               = "#c22a2a";
const left_hurdle_step_color                = "#6621c4";
const right_hurdle_step_color               = "#2e78e7";
const left_inline_lunge_color               = "#bf56fc";
const right_inline_lunge_color              = "#fc9856";
const left_shoulder_mobility_color          = "#fc56a0"
const right_shoulder_mobility_color         = "#1bc9de";
const left_active_straight_leg_raise_color  = "#3da211";

// change color
const right_active_straight_leg_raise_color = "#fc9856";
const trunk_stability_pushup_color          = "#fc56a0"
const left_rotary_stability_color           = "#1bc9de";
const right_rotary_stability_color          = "#3da211";

const SPINALROM_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Deep Squat',  data: "deep_squat_data", color: deep_squat_color, strokeWidth: 14},
    {title: 'Left Hurdle Step', data: "left_hurdle_step_data", color: left_hurdle_step_color, strokeWidth: 14 },
    {title: 'Right Hurdle Step', data: "right_hurdle_step_data", color: right_hurdle_step_color, strokeWidth: 14 },
    {title: 'Left Inline Lunge', data: "left_inline_lunge_data", color: left_inline_lunge_color, strokeWidth: 14 },
    {title: 'Right Inline Lunge', data: "right_inline_lunge_data", color: right_inline_lunge_color, strokeWidth: 14 },
    {title: 'Left Shoulder Mobility', data: "left_shoulder_mobility_data", color: left_shoulder_mobility_color, strokeWidth: 14 },
];

const SPINALROM_LEGEND2 = [
    {title: 'Right Shoulder Mobility', data: "right_shoulder_mobility_data", color: right_shoulder_mobility_color, strokeWidth: 14 },
    {title: 'Left Active Straight Leg Raise', data: "left_active_straight_leg_raise_data", color: left_active_straight_leg_raise_color, strokeWidth: 14 },
    {title: 'Right Active Straight Leg Raise', data: "right_active_straight_leg_raise_data", color: right_active_straight_leg_raise_color, strokeWidth: 14 },
    {title: 'Trunk Stability Pushup', data: "trunk_stability_pushup_data", color: trunk_stability_pushup_color, strokeWidth: 14 },
    {title: 'Left Rotary Stability', data: "left_rotary_stability_data", color: left_rotary_stability_color, strokeWidth: 14 },
    {title: 'Right Rotary Stability', data: "right_rotary_stability_data", color: right_rotary_stability_color, strokeWidth: 14 },

];

var deep_squat_data              = [];
var left_hurdle_step_data               = [];
var right_hurdle_step_data              = [];
var left_inline_lunge_data              = [];
var right_inline_lunge_data             = [];
var left_shoulder_mobility_data         = [];
var right_shoulder_mobility_data        = [];
var left_active_straight_leg_raise_data = [];
var right_active_straight_leg_raise_data = [];
var trunk_stability_pushup_data          = [];
var left_rotary_stability_data           = [];
var right_rotary_stability_data          = [];

var legend1_title  = "Deep Squat";
var legend2_title  = "Left Hurdle Step";
var legend3_title  = "Right Hurdle Step";
var legend4_title  = "Left Inline Lunge";
var legend5_title  = "Right Inline Lunge";
var legend6_title  = "Left Shoulder Mobility";
var legend7_title  = "Right Shoulder Mobility";
var legend8_title  = "Left Active Straight Leg Raise";
var legend9_title  = "Right Active Straight Leg Raise";
var legend10_title = "Trunk Stability Pushup";
var legend11_title = "Left Rotary Stability";
var legend12_title = "Right Rotary Stability";

export default class AssessSpinalROM extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading:       false,
            title:           "Functional Movement Assessment",
            all_data:        true,
            crosshairValues: [],
        }
    }

    componentDidMount() {

        try {
            this.getClientData();

        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        deep_squat_data                      = [];
        left_hurdle_step_data                = [];
        right_hurdle_step_data               = [];
        left_inline_lunge_data               = [];
        right_inline_lunge_data              = [];
        left_shoulder_mobility_data          = [];
        right_shoulder_mobility_data         = [];
        left_active_straight_leg_raise_data  = [];
        right_active_straight_leg_raise_data = [];
        trunk_stability_pushup_data          = [];
        left_rotary_stability_data           = [];
        right_rotary_stability_data          = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsFMS;

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.fms;
            var ctr = 0;

            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var deep_squat                      = data[key].deep_squat;
                var left_hurdle_step                = data[key].left_hurdle_step;
                var right_hurdle_step               = data[key].right_hurdle_step;
                var left_inline_lunge               = data[key].left_inline_lunge;
                var right_inline_lunge              = data[key].right_inline_lunge
                var left_shoulder_mobility          = data[key].left_shoulder_mobility;
                var right_shoulder_mobility         = data[key].right_shoulder_mobility;
                var left_active_straight_leg_raise  = data[key].left_active_straight_leg_raise;
                var right_active_straight_leg_raise = data[key].right_active_straight_leg_raise;
                var trunk_stability_pushup          = data[key].trunk_stability_pushup;
                var left_rotary_stability           = data[key].left_rotary_stability;
                var right_rotary_stability          = data[key].right_rotary_stability;

                var date_created        = data[key].date_created;
                var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                left_active_straight_leg_raise_data.push({"x": date, "y": left_active_straight_leg_raise});// test_arr[ctr++]});
                deep_squat_data.push({"x": date, "y": deep_squat});
                left_hurdle_step_data.push({"x": date, "y": left_hurdle_step});
                right_hurdle_step_data.push({"x": date, "y": right_hurdle_step});
                left_inline_lunge_data.push({"x": date, "y": left_inline_lunge});
                right_inline_lunge_data.push({"x": date, "y": right_inline_lunge});
                left_shoulder_mobility_data.push({"x": date, "y": left_shoulder_mobility});
                right_shoulder_mobility_data.push({"x": date, "y": right_shoulder_mobility});

                right_active_straight_leg_raise_data.push({"x": date, "y": right_active_straight_leg_raise});
                trunk_stability_pushup_data.push({"x": date, "y": trunk_stability_pushup});
                left_rotary_stability_data.push({"x": date, "y": left_rotary_stability});
                right_rotary_stability_data.push({"x": date, "y": right_rotary_stability});

                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(deep_squat, left_hurdle_step, right_hurdle_step, left_inline_lunge, right_inline_lunge, left_shoulder_mobility, right_shoulder_mobility, left_active_straight_leg_raise, right_active_straight_leg_raise, trunk_stability_pushup, left_rotary_stability, right_rotary_stability)
            }

            this.setState({
                report_data: data.length,
                all_data: true,
                left_active_straight_leg_raise_data: left_active_straight_leg_raise_data,
                deep_squat_data: deep_squat_data,
                left_hurdle_step_data: left_hurdle_step_data,
                right_hurdle_step_data: right_hurdle_step_data,
                left_inline_lunge_data: left_inline_lunge_data,
                right_inline_lunge_data: right_inline_lunge_data,
                left_shoulder_mobility_data: left_shoulder_mobility_data,
                right_shoulder_mobility_data: right_shoulder_mobility_data,
                right_active_straight_leg_raise_data: right_active_straight_leg_raise_data,
                trunk_stability_pushup_data: trunk_stability_pushup_data,
                left_rotary_stability_data: left_rotary_stability_data,
                right_rotary_stability_data: right_rotary_stability_data
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeave = () =>{
        this.setState({crosshairValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXTooltip = (value, {index}) => {
        var x   = deep_squat_data[index].y;
        var x2  = deep_squat_data[index].x;
        var y1  = left_hurdle_step_data[index].y;
        var y2  = right_hurdle_step_data[index].y;
        var y3  = left_inline_lunge_data[index].y;
        var y4  = right_inline_lunge_data[index].y;
        var y5  = left_shoulder_mobility_data[index].y;
        var y6  = right_shoulder_mobility_data[index].y;
        var y7  = left_active_straight_leg_raise_data[index].y;
        var y8  = right_active_straight_leg_raise_data[index].y;
        var y9  = trunk_stability_pushup_data[index].y;
        var y10 = left_rotary_stability_data[index].y;
        var y11 = right_rotary_stability_data[index].y;

        this.setState({
                        crosshairValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY3: y3,
                        crossHairY4: y4,
                        crossHairY5: y5,
                        crossHairY6: y6,
                        crossHairY7: y7,
                        crossHairY8: y8,
                        crossHairY9: y9,
                        crossHairY10: y10,
                        crossHairY11: y11,
                      });
    };

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "deep_squat_data")                   dataset = {"deep_squat_data":deep_squat_data};
            else if(data === "left_hurdle_step_data")               dataset = {"left_hurdle_step_data":left_hurdle_step_data};
            else if(data === "right_hurdle_step_data")              dataset = {"right_hurdle_step_data":right_hurdle_step_data};
            else if(data === "left_inline_lunge_data")              dataset = {"left_inline_lunge_data": left_inline_lunge_data};
            else if(data === "right_inline_lunge_data")             dataset = {"right_inline_lunge_data": right_inline_lunge_data};
            else if(data === "left_shoulder_mobility_data")         dataset = {"left_shoulder_mobility_data": left_shoulder_mobility_data};
            else if(data === "right_shoulder_mobility_data")        dataset = {"right_shoulder_mobility_data": right_shoulder_mobility_data};
            else if(data === "left_active_straight_leg_raise_data") dataset = {"left_active_straight_leg_raise_data": left_active_straight_leg_raise_data};

            else if(data === "right_active_straight_leg_raise_data") dataset = {"right_active_straight_leg_raise_data": right_active_straight_leg_raise_data};
            else if(data === "trunk_stability_pushup_data") dataset = {"trunk_stability_pushup_data": trunk_stability_pushup_data};
            else if(data === "left_rotary_stability_data") dataset = {"left_rotary_stability_data": left_rotary_stability_data};
            else if(data === "right_rotary_stability_data") dataset = {"right_rotary_stability_data": right_rotary_stability_data};

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                deep_squat_data: [],
                left_hurdle_step_data: [],
                right_hurdle_step_data: [],
                left_inline_lunge_data: [],
                right_inline_lunge_data: [],
                left_shoulder_mobility_data: [],
                right_shoulder_mobility_data: [],
                left_active_straight_leg_raise_data: [],
                right_active_straight_leg_raise_data: [],
                trunk_stability_pushup_data: [],
                left_rotary_stability_data: [],
                right_rotary_stability_data: []
            }, function (){
                this.setState(dataset);
            })
        }

        //const {items} = this.state;
        //item.disabled = !item.disabled;
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "45%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend4_title }: {this.state.crossHairY3}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend5_title }: {this.state.crossHairY4}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend6_title }: {this.state.crossHairY5}</span>
                    </span>
                    <span style={{display:"inline-block", width: "55%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend7_title }: {this.state.crossHairY6}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend8_title }: {this.state.crossHairY7}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend9_title }: {this.state.crossHairY8}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend10_title }: {this.state.crossHairY9}</span>
                        <span style={{display: "block",fontSize:16}}>{ legend11_title }: {this.state.crossHairY10}</span>
                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var crosshair;
        if(dataset == "deep_squat_data") {
            legend    = legend1_title;
            crosshair = this.state.crossHairX;
        } else if(dataset == "left_hurdle_step_data") {
            legend    = legend2_title;
            crosshair = this.state.crossHairY1;
        } else if(dataset == "right_hurdle_step_data") {
            legend    = legend3_title;
            crosshair = this.state.crossHairY2;
        } else if(dataset == "left_inline_lunge_data") {
            legend    = legend4_title;
            crosshair = this.state.crossHairY3;
        } else if(dataset == "right_inline_lunge_data") {
            legend    = legend5_title;
            crosshair = this.state.crossHairY4;
        } else if(dataset == "left_shoulder_mobility_data") {
            legend    = legend6_title;
            crosshair = this.state.crossHairY5;
        } else if(dataset == "right_shoulder_mobility_data") {
            legend    = legend7_title;
            crosshair = this.state.crossHairY6;
        } else if(dataset == "left_active_straight_leg_raise_data") {
            legend    = legend8_title;
            crosshair = this.state.crossHairY7;
        } else if(dataset == "right_active_straight_leg_raise_data") {
            legend    = legend9_title;
            crosshair = this.state.crossHairY8;
        } else if(dataset == "trunk_stability_pushup_data") {
            legend    = legend10_title;
            crosshair = this.state.crossHairY9;
        } else if(dataset == "left_rotary_stability_data") {
            legend    = legend11_title;
            crosshair = this.state.crossHairY10;
        } else if(dataset == "right_rotary_stability_data") {
            legend    = legend12_title;
            crosshair = this.state.crossHairY11;
        }
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { crosshair }</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var all_data  = this.state.all_data;
        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>

        var tooltip;
        var tooltip_width = 300;
        if(all_data) {
            tooltip_width = 490;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="weight" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[0, 3]}
                                                     onMouseLeave = {this.onMouseLeave}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                     <YAxis title="Score" {...axisProps}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.deep_squat_data}           size={2.5} color={deep_squat_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.left_hurdle_step_data}          size={2.5} color={left_hurdle_step_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.right_hurdle_step_data}        size={2.5} color={right_hurdle_step_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.left_inline_lunge_data}              size={2.5} color={left_inline_lunge_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.right_inline_lunge_data}             size={2.5} color={right_inline_lunge_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.left_shoulder_mobility_data}         size={2.5} color={left_shoulder_mobility_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.right_shoulder_mobility_data}        size={2.5} color={right_shoulder_mobility_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.left_active_straight_leg_raise_data} size={2.5} color={left_active_straight_leg_raise_color} onNearestX={this.onNearestXTooltip}/>

                                  <LineMarkSeries data={this.state.right_active_straight_leg_raise_data} size={2.5} color={right_active_straight_leg_raise_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.trunk_stability_pushup_data}          size={2.5} color={trunk_stability_pushup_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.left_rotary_stability_data}           size={2.5} color={left_rotary_stability_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.right_rotary_stability_data}          size={2.5} color={right_rotary_stability_color} onNearestX={this.onNearestXTooltip}/>

                                  <Crosshair values={this.state.crosshairValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={SPINALROM_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                    <DiscreteColorLegend items={SPINALROM_LEGEND2}
                                                          orientation='horizontal'
                                                          onItemClick={this.handleLegendClick}
                                                          style={{display: "inline-block", position:"relative", width:900, top:-20, left:35}}/>
                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessFMS.js